if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.quantityInput = this.form.querySelector('[name=quantity]');
        this.syncPdpQuantityVariant = this.syncPdpQuantityVariant.bind(this);
        this.addEventListener('click', this.onProductFormClick.bind(this), true);
        if (this.quantityInput) {
          this.quantityInput.addEventListener('change', this.syncPdpQuantityVariant);
          this.quantityInput.addEventListener('input', this.syncPdpQuantityVariant);
        }
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.syncPdpQuantityVariant();
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        this.syncPdpQuantityVariant();
        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                    if (window.zarfNormalizeAcBlanketCart) window.zarfNormalizeAcBlanketCart(this.getCartRenderer());
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
              if (window.zarfNormalizeAcBlanketCart) window.zarfNormalizeAcBlanketCart(this.getCartRenderer());
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      getCartRenderer() {
        return document.querySelector('cart-drawer-items') || document.querySelector('cart-items');
      }

      onProductFormClick(event) {
        if (event.target.closest('.quantity__button')) {
          setTimeout(this.syncPdpQuantityVariant);
        }

        if (event.target.closest('.shiprocket-headless[data-type="product"] .sr-headless-checkout')) {
          this.syncPdpQuantityVariant();
          const quantity = this.quantityInput ? parseInt(this.quantityInput.value, 10) || 1 : 1;

          if (quantity > 1) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            this.form.requestSubmit();
          }
        }
      }

      savePdpVariantPair(normalVariantId, bundleVariantId) {
        if (!normalVariantId || !bundleVariantId) return;

        if (window.zarfSaveAcBlanketVariantPair) {
          window.zarfSaveAcBlanketVariantPair(normalVariantId, bundleVariantId, this.dataset.productType);
          return;
        }

        try {
          const productType = (this.dataset.productType || '').toLowerCase().trim();
          const normalizedProductType =
            productType === 'bedsheet' || productType === 'bedsheets' ? 'bedsheet' : 'ac blanket';
          const pairs = JSON.parse(window.localStorage.getItem('zarfAcBlanketVariantPairs')) || {};
          pairs.normalToDiscount = pairs.normalToDiscount || {};
          pairs.discountToNormal = pairs.discountToNormal || {};
          pairs.normalToProductType = pairs.normalToProductType || {};
          pairs.discountToProductType = pairs.discountToProductType || {};
          pairs.normalToDiscount[normalVariantId] = bundleVariantId;
          pairs.discountToNormal[bundleVariantId] = normalVariantId;
          pairs.normalToProductType[normalVariantId] = normalizedProductType;
          pairs.discountToProductType[bundleVariantId] = normalizedProductType;
          window.localStorage.setItem('zarfAcBlanketVariantPairs', JSON.stringify(pairs));
        } catch (error) {
          // The cart still has Liquid data attributes when storage is unavailable.
        }
      }

      syncPdpQuantityVariant() {
        const variantInput = this.form.querySelector('[name=id]');
        const productUrlInput = this.form.querySelector('[name=productUrl]');
        const quantity = this.quantityInput ? parseInt(this.quantityInput.value, 10) || 1 : 1;

        // Keep this collection on the selected product/variant. Its offer is a cart-drawer presentation only.
        if (this.dataset.zarfPairOffer === 'buy-2-at-9999') return;

        const bundleVariantId = this.dataset.bundleVariantId || this.dataset.discountVariantId;
        const normalVariantId = this.dataset.normalVariantId;
        const targetVariantId = quantity >= 2 ? bundleVariantId : normalVariantId;

        this.savePdpVariantPair(normalVariantId, bundleVariantId);

        if (!targetVariantId || !variantInput) return;

        variantInput.value = targetVariantId;

        if (productUrlInput) {
          const productUrl = new URL(productUrlInput.value, window.location.origin);
          productUrl.searchParams.set('variant', targetVariantId);
          productUrlInput.value = `${productUrl.pathname}${productUrl.search}`;
        }
      }
    }
  );
}
